import { render, staticRenderFns } from "./partnersIntroduction.vue?vue&type=template&id=5192e4d4&"
import script from "./partnersIntroduction.vue?vue&type=script&lang=js&"
export * from "./partnersIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./partnersIntroduction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports